import React from 'react'
import InfoContent from 'components/InfoContent'

import step1 from './img/step-01.png'
import step2 from './img/step-02.png'
import step3 from './img/step-03.png'
import step4 from './img/step-04.png'
import step5 from './img/step-05.png'
import step6 from './img/step-06.png'
import step7 from './img/step-07.png'
import step8 from './img/step-08.png'
import step9 from './img/step-09.png'
import step10 from './img/step-10.png'
import step11 from './img/step-11.png'
import step12 from './img/step-12.png'
import { Button } from 'antd'
import { useHistory } from 'react-router'
import { useLayoutHeader } from 'components/MainLayout'

const headerConfig = {
    menuEnabled: false,
    closeable: true,
}
const contents = [
    {
        description: "تنها در مناطق و مسیرهای مجاز از رورو استفاده کنید",
        img: step1
    },
    {
        description: "یک رورو در نزدیکی خود پیدا کنید. با زدن یک دکمه در اپ و اسکن کد اسکوتر، قفل آن را باز کنید.",
        img: step2
    },
    {
        description: "برای ایمنی خود، لطفا در هنگام رانندگی از کلاه کاسکت استفاده کنید",
        img: step3
    },
    {
        description: "پیش از شروع حرکت، جک را از روی زمین بلند کنید.",
        img: step4
    },
    {
        description: "با یک پای خود به زمین فشار وارد کنید تا اسکوتر به حرکت درآید. سپس دکمه گاز را فشار دهید و رانندگی خود را شروع کنید.",
        img: step5
    },
    {
        description: "بدون حرکات نمایشی رانندگی کنید.",
        img: step6
    },
    {
        description: "در هنگام اسکوتر، هر دو پای خود را به شکل صحیح روی کفپوش قرار دهید.",
        img: step7
    },
    {
        description: "مسیر عابران پیاده را مسدود نکنید.",
        img: step8
    },
    {
        description: "مراقب موانع مسیر مانند چاله‌ها و سنگ‌ها باشید.",
        img: step9
    },
    {
        description: "هرگز روی پلکان‌های شهری رانندگی نکنید.",
        img: step10
    },
    {
        description: "همیشه از قوانین راهنمایی و رانندگی پیروی کنید.",
        img: step11
    },
    {
        description: "برای توقف، ترمز دستی را فشار دهید.",
        img: step12
    },
]

export default function RideGuide(props) {
    const history = useHistory()
    useLayoutHeader(headerConfig)
    const onClose = () => {
        history.goBack()
    }
    return <>
        <InfoContent contents={contents} autoplay={true}
            mainAction={<Button type="primary" block onClick={onClose}>گرفتم، بزن بریم</Button>} />
    </>
}